// extracted by mini-css-extract-plugin
module.exports = {"root":"_3tyuOOrnTLbf1NFYybm-Q_","imgContainer":"_1RTTKjSRmxUgRdHzy7uz5R","image":"_1kQXdmBa6PgLHms1-dF34N","tabBar":"Gxk0CMhvrC6nLoz6bMSEM"};